export enum LANGUAGES {
  EN = 'EN',
  DE = 'DE',
}

export const ROLES = {
  ROLE_SUPERADMIN: 'Superadmin',
  ROLE_ADMIN: 'Admin',
  ROLE_MODERATOR: 'Moderator',
};

export const ACCESS_TOKEN_NAME = 'accessToken';
export const APP_LANG_NAME = 'lang';
